import React, { useEffect, useState } from 'react';

function SelfHelpPage() {
  const [selectedTool, setSelectedTool] = useState(null);
  const [readingBook, setReadingBook] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);

  // Dummy book data for the reader
  const dummyBooks = {
    'Mental Health Workbook': [
      { title: 'Chapter 1: Understanding Yourself', content: 'This is the first page of the Mental Health Workbook. It focuses on identifying your triggers and understanding your emotional baseline...' },
      { title: 'Chapter 2: Daily Reflections', content: 'Writing down your thoughts daily can help you process complex emotions. Try listing three things you are grateful for today...' },
      { title: 'Chapter 3: Cognitive Reframing', content: 'Learn to challenge negative thoughts by asking: Is there another way to look at this situation? What evidence do I have for this thought?' }
    ],
    'Anxiety Management Guide': [
      { title: 'Introduction to Anxiety', content: 'Anxiety is a natural response to stress. This guide will help you navigate through common symptoms and management techniques...' },
      { title: 'Deep Breathing Exercises', content: 'Page 2: Practice "Box Breathing". Inhale for 4, hold for 4, exhale for 4, hold for 4. Repeat until you feel centered.' },
      { title: 'Grounding Techniques', content: 'The 5-4-3-2-1 technique: Identify 5 things you see, 4 you can touch, 3 you hear, 2 you can smell, and 1 you can taste.' }
    ]
  };

  const openBook = (title) => {
    const bookContent = dummyBooks[title] || [
      { title: 'Generic Resource', content: 'Full content for this resource is currently being processed by the Admin.' },
      { title: 'Next Steps', content: 'Stay tuned for more updates in our digital library.' }
    ];
    setReadingBook({ title, pages: bookContent });
    setCurrentPage(0);
  };

  const closeReader = () => {
    setReadingBook(null);
    setCurrentPage(0);
  };

  const tools = [
    {
      id: 1,
      name: 'Audio Resources',
      icon: '🎵',
      description: 'Listen to guided audio resources uploaded by our experienced therapists',
      duration: 'Variable length',
      sessions: [
        { title: 'Sample Audio 1', duration: 'Uploaded by therapist' },
        { title: 'Sample Audio 2', duration: 'Uploaded by therapist' }
      ]
    },
    {
      id: 2,
      name: 'Podcasts',
      icon: '🎧',
      description: 'Read educational materials and PDFs shared by admin and therapists',
      duration: 'Read online',
      sessions: [
        { title: 'Sample Podcast 1', duration: 'PDF resource' },
        { title: 'Sample Podcast 2', duration: 'PDF resource' }
      ]
    },
    {
      id: 3,
      name: 'Activities',
      icon: '📝',
      description: 'Access interactive activities and worksheets for practical mental wellness',
      duration: 'Self-paced',
      sessions: [
        { title: 'Sample Activity 1', duration: 'PDF activity' },
        { title: 'Sample Activity 2', duration: 'PDF activity' }
      ]
    }
  ];

  useEffect(() => {
    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);
  }, []);

  return (
    <>
      {/* Page Header Start */}
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-2-1.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Self-Help Tools</h2>
            <ul className="thm-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><span>Self-Help</span></li>
            </ul>
          </div>
        </div>
      </section>
      {/* Page Header End */}

      {/* Self-Help Section Start */}
      <section className="self-help-section" style={{
        padding: '80px 0',
        background: 'linear-gradient(120deg, #f8fafc 0%, #e0e7ff 100%)',
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center wow fadeInUp" style={{ marginBottom: '50px' }}>
                <span className="section-title__tagline" style={{ color: '#7c3aed', fontWeight: 600, fontSize: '1.1rem', letterSpacing: '0.04em' }}>Wellness Tools</span>
                <h2 className="section-title__title" style={{ fontSize: '2.5rem', fontWeight: 800, color: '#2d2d4d', marginBottom: '18px' }}>Self-Help Resources</h2>
                <p style={{ color: '#555', fontSize: '1.13rem', maxWidth: '420px', margin: '0 auto' }}>
                  Access guided exercises, meditations, and tools to support your mental wellness journey
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            {tools.map((tool) => (
              <div key={tool.id} className="col-lg-4 col-md-6 wow fadeInUp" style={{ marginBottom: '32px', display: 'flex' }}>
                <div
                  className="tool-card"
                  onClick={() => setSelectedTool(selectedTool?.id === tool.id ? null : tool)}
                  style={{
                    background: 'rgba(255,255,255,0.92)',
                    backdropFilter: 'blur(4px)',
                    padding: '32px',
                    borderRadius: '18px',
                    cursor: 'pointer',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    textAlign: 'center',
                    border: selectedTool?.id === tool.id ? '2px solid #7c3aed' : '2px solid #f3f3fa',
                    transform: selectedTool?.id === tool.id ? 'translateY(-7px) scale(1.03)' : 'translateY(0) scale(1)',
                    boxShadow: selectedTool?.id === tool.id ? '0 10px 30px rgba(124,58,237,0.13)' : '0 6px 32px rgba(80,80,120,0.13)',
                    minHeight: '340px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}
                >
                  <div style={{ fontSize: '54px', marginBottom: '18px', filter: selectedTool?.id === tool.id ? 'drop-shadow(0 2px 8px #7c3aed33)' : 'none', transition: 'filter 0.2s' }}>{tool.icon}</div>
                  <h3 style={{ marginBottom: '10px', fontSize: '1.22rem', fontWeight: 700, color: '#2d2d4d' }}>{tool.name}</h3>
                  <p style={{ marginBottom: '15px', color: '#666', fontSize: '1.05rem' }}>{tool.description}</p>
                  <span style={{
                    display: 'inline-block',
                    backgroundColor: '#ede9fe',
                    color: '#7c3aed',
                    padding: '6px 16px',
                    borderRadius: '20px',
                    fontSize: '13px',
                    fontWeight: 600,
                    marginBottom: '6px'
                  }}>
                    ⏱ {tool.duration}
                  </span>

                  {selectedTool?.id === tool.id && (
                    <div style={{
                      marginTop: '22px',
                      paddingTop: '22px',
                      borderTop: '1.5px solid #e0e7ff',
                      animation: 'fadeInDown 0.5s cubic-bezier(.4,2,.6,1)'
                    }}>
                      <h4 style={{ marginBottom: '15px', textAlign: 'left', fontWeight: 700, color: '#7c3aed' }}>Available Sessions:</h4>
                      <ul style={{
                        listStyle: 'none',
                        padding: 0,
                        textAlign: 'left',
                        fontSize: '1.05rem',
                        color: '#444'
                      }}>
                        {tool.sessions.map((session, idx) => (
                          <li
                            key={idx}
                            onClick={(e) => {
                              if (tool.id === 5) {
                                e.stopPropagation();
                                openBook(session.title);
                              }
                            }}
                            style={{
                              padding: '10px',
                              marginBottom: '8px',
                              backgroundColor: '#f9f9ff',
                              borderRadius: '7px',
                              fontSize: '15px',
                              fontWeight: 500,
                              cursor: tool.id === 5 ? 'pointer' : 'default',
                              border: tool.id === 5 ? '1px solid #e0e7ff' : 'none',
                              transition: 'all 0.2s'
                            }}
                            onMouseEnter={(e) => { if (tool.id === 5) e.currentTarget.style.backgroundColor = '#f0f0ff'; }}
                            onMouseLeave={(e) => { if (tool.id === 5) e.currentTarget.style.backgroundColor = '#f9f9ff'; }}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span>{session.title}</span>
                              <span style={{ color: '#7c3aed', fontWeight: 600 }}>{session.duration}</span>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <button className="thm-btn" style={{
                        width: '100%',
                        marginTop: '15px',
                        fontWeight: 700,
                        fontSize: '1.08rem',
                        borderRadius: '8px',
                        background: '#7c3aed',
                        color: '#fff',
                        boxShadow: '0 2px 8px rgba(124,58,237,0.08)'
                      }}>
                        {tool.id === 5 ? 'Open Library Viewer' : 'Start Now'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Tips Section */}
          <div className="row" style={{ marginTop: '54px' }}>
            <div className="col-lg-12">
              <div className="tips-section wow fadeInUp" style={{
                background: 'rgba(255,255,255,0.92)',
                backdropFilter: 'blur(4px)',
                padding: '44px',
                borderRadius: '18px',
                boxShadow: '0 6px 32px rgba(80,80,120,0.13)',
                border: '2px solid #f3f3fa',
                fontSize: '1.08rem',
                color: '#444',
                marginBottom: '0',
              }}>
                <h3 style={{ marginBottom: '30px', color: '#7c3aed', fontWeight: 800 }}>💡 Tips for Using These Tools</h3>
                <div className="row">
                  <div className="col-md-6" style={{ marginBottom: '20px' }}>
                    <div style={{ paddingRight: '20px' }}>
                      <h4 style={{ fontWeight: 700, color: '#2d2d4d' }}>✓ Consistency is Key</h4>
                      <p>Set aside time each day for these exercises. Even 10 minutes daily can make a significant difference in your mental health.</p>
                    </div>
                  </div>
                  <div className="col-md-6" style={{ marginBottom: '20px' }}>
                    <div style={{ paddingRight: '20px' }}>
                      <h4 style={{ fontWeight: 700, color: '#2d2d4d' }}>✓ Find What Works</h4>
                      <p>Different tools work for different people. Try various resources to discover what resonates best with you.</p>
                    </div>
                  </div>
                  <div className="col-md-6" style={{ marginBottom: '20px' }}>
                    <div style={{ paddingRight: '20px' }}>
                      <h4 style={{ fontWeight: 700, color: '#2d2d4d' }}>✓ Combine with Professional Help</h4>
                      <p>These tools complement professional therapy. Use them alongside sessions with your therapist for best results.</p>
                    </div>
                  </div>
                  <div className="col-md-6" style={{ marginBottom: '20px' }}>
                    <div style={{ paddingRight: '20px' }}>
                      <h4 style={{ fontWeight: 700, color: '#2d2d4d' }}>✓ Track Your Progress</h4>
                      <p>Use our wellness tracker to monitor your improvement. Small wins add up to significant progress over time.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Self-Help Section End */}

      {/* Book Reader Overlay */}
      {readingBook && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.85)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: '#fff',
            width: '90%',
            maxWidth: '800px',
            height: '80vh',
            borderRadius: '20px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
          }}>
            {/* Header */}
            <div style={{
              padding: '20px',
              borderBottom: '1px solid #eee',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: '#f8fafc'
            }}>
              <h3 style={{ margin: 0, color: '#2d2d4d' }}>{readingBook.title}</h3>
              <button
                onClick={closeReader}
                style={{
                  border: 'none',
                  background: '#ef4444',
                  color: '#fff',
                  width: '35px',
                  height: '35px',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                ×
              </button>
            </div>

            {/* Content Area with Arrows */}
            <div style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              padding: '20px',
              position: 'relative'
            }}>
              {/* Left Arrow */}
              <button
                disabled={currentPage === 0}
                onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
                style={{
                  position: 'absolute',
                  left: '10px',
                  zIndex: 2,
                  background: 'rgba(124,58,237,0.1)',
                  border: '2px solid #7c3aed',
                  color: '#7c3aed',
                  width: '45px',
                  height: '45px',
                  borderRadius: '50%',
                  cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
                  fontSize: '24px',
                  opacity: currentPage === 0 ? 0.3 : 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                ←
              </button>

              {/* Page Content */}
              <div style={{
                flex: 1,
                padding: '0 60px',
                textAlign: 'center',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}>
                <h4 style={{ color: '#7c3aed', marginBottom: '20px', fontSize: '1.5rem' }}>
                  {readingBook.pages[currentPage].title}
                </h4>
                <p style={{
                  fontSize: '1.2rem',
                  lineHeight: '1.8',
                  color: '#444',
                  maxHeight: '400px',
                  overflowY: 'auto'
                }}>
                  {readingBook.pages[currentPage].content}
                </p>
                <div style={{
                  marginTop: 'auto',
                  color: '#999',
                  fontSize: '0.9rem'
                }}>
                  Page {currentPage + 1} of {readingBook.pages.length}
                </div>
              </div>

              {/* Right Arrow */}
              <button
                disabled={currentPage === readingBook.pages.length - 1}
                onClick={() => setCurrentPage(prev => Math.min(readingBook.pages.length - 1, prev + 1))}
                style={{
                  position: 'absolute',
                  right: '10px',
                  zIndex: 2,
                  background: 'rgba(124,58,237,0.1)',
                  border: '2px solid #7c3aed',
                  color: '#7c3aed',
                  width: '45px',
                  height: '45px',
                  borderRadius: '50%',
                  cursor: currentPage === readingBook.pages.length - 1 ? 'not-allowed' : 'pointer',
                  fontSize: '24px',
                  opacity: currentPage === readingBook.pages.length - 1 ? 0.3 : 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                →
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SelfHelpPage;
